import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function StarStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12 1.75C12.3111 1.75 12.5903 1.94182 12.7012 2.23242L15.0586 8.41211L21.5371 8.72949C21.8421 8.74461 22.1074 8.94312 22.208 9.23145C22.3086 9.5198 22.2246 9.84048 21.9951 10.042L17.0645 14.3691L18.877 21.3105C18.956 21.6135 18.8382 21.9333 18.5821 22.1133C18.3258 22.2933 17.9848 22.2954 17.7266 22.1182L12 18.1875L6.27347 22.1182C6.0153 22.2954 5.67425 22.2933 5.418 22.1133C5.16187 21.9333 5.04402 21.6135 5.12308 21.3105L6.9346 14.3691L2.00491 10.042C1.77546 9.84048 1.69151 9.5198 1.79202 9.23145C1.89265 8.94312 2.15795 8.74461 2.46292 8.72949L8.94046 8.41211L11.2989 2.23242L11.3487 2.12891C11.4805 1.89731 11.7277 1.75 12 1.75ZM10.168 9.40527C10.0618 9.68322 9.80116 9.87218 9.50394 9.88672L4.38675 10.1367L8.27249 13.5479C8.48559 13.735 8.57558 14.0263 8.50394 14.3008L7.08206 19.7432L11.5752 16.6592C11.831 16.4836 12.1691 16.4836 12.4248 16.6592L16.917 19.7432L15.4961 14.3008C15.4245 14.0263 15.5145 13.735 15.7276 13.5479L19.6123 10.1367L14.4961 9.88672C14.1989 9.87218 13.9383 9.68323 13.8321 9.40527L12 4.60449L10.168 9.40527Z"
				fill="currentColor"
			/>
		</svg>
	);
}

StarStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default StarStrokeIcon;
